
import { Vue, Options } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import TextboxField from '@/components/validateFields/TextboxField.vue'
import { useI18n } from 'vue-i18n'
import { IProjectCustomField } from '@/utils/types'

@Options({
  components: { TextboxField },
  name: 'Textbox',
})
export default class WeightMeasurement extends Vue {
  @Prop({ type: Object }) readonly customField!: IProjectCustomField
  isLockedChangingApiKey = false
  private t = useI18n().t
  created() {
    this.isLockedChangingApiKey = !!this.customField.hasEncryptedApiKey && this.customField.apiKey === ''
  }

  handleUnlockApiKey() {
    this.isLockedChangingApiKey = false
  }

  get shouldAllowInputApiKey() {
    return !this.isLockedChangingApiKey
  }
}
